import $ from 'jquery';
import Service from '../lib/ajax/Service';
import { EventHandler } from '../../utils/dom-events';


class ContentEditor {
  listen() {
    const $doc = $(document);

    new EventHandler(document.documentElement, 'click', (event) => {
      const { classList } = event.target;

      // classList is not available on SVG elements in IE
      if (classList && classList.contains('tn-content-editor')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showEditor(event.target);
      }
    }, { capture: true }).start();

    $doc.on('click', '#tn-content-save', () => {
      this.saveContent();
    });
  }

  showEditor(icon) {
    const $icon = $(icon);

    this.destroyAllInstances();
    const editorSelector = 'textarea.wysiwyg-text-editor';

    $(editorSelector).val('');

    const fieldKey = $icon.attr('data-tn-for-field');
    const fieldType = $icon.attr('data-tn-field-type');
    const fieldLevel = $icon.attr('data-tn-field-level');

    const contentValue = $icon.attr('data-tn-content-zzz');

    this.content = {
      fieldKey,
      fieldType,
      fieldLevel,
    };

    let html = '';

    if (contentValue) {
      html = contentValue;
    } else {
      html = $(`[data-tn-field="${fieldKey}"]`).html();
    }

    $(editorSelector).val(html);

    const isPlainText = fieldType.indexOf('PlainText') > -1;

    const config = {};
    if (isPlainText) {
      config.toolbar = [];
      config.startupMode = 'source';
    } else {
      config.toolbar = 'Basic';
      config.startupMode = 'wysiwyg';
      config.autoParagraph = false;
      config.allowedContent = true;
      config.removePlugins = 'magicline';
    }

    $(editorSelector).ckeditor(() => {
      // console.log('instance loaded');
    }, config);

    $('#tn-content-editor-modal').modal('show');
  }

  destroyAllInstances() {
    Object.values(CKEDITOR.instances).forEach((instance) => {
      instance.destroy();
    });
  }

  saveContent() {
    const content = this.content;
    const fieldKey = content.fieldKey;
    const fieldLevel = content.fieldLevel;

    const html = CKEDITOR.instances['tn-content-editor'].getData();
    const data = {
      fieldKey,
      value: html,
    };
    let url;

    if (fieldLevel === 'page') {
      const main = document.getElementsByTagName('main')[0];
      const pageKey = main.dataset.tnPageType;

      url = `api/system/pages/${pageKey}/fields/${fieldKey}`;
    } else {
      url = `api/system/components/fields/${fieldKey}`;
    }

    new Service()
      .put(url, data)
      .done(() => {
        $(`[data-tn-field="${fieldKey}"]`).html(html);
        $('#tn-content-editor-modal').modal('hide');
      })
      .fail(() => {
        alert('Unknown error, failed to save.');
      });
  }
}

export default ContentEditor;



// WEBPACK FOOTER //
// ./V7/tnew/lib/ContentEditor.js